import React, { useState, useEffect } from "react";
import BubbleChart from ".././utils/charts/d3Graphs/BubbleChart";
import HighCharts from "../utils/charts/HighCharts/index";
import uuid from "react-uuid";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";
// import GridChart from "./GridChart";
import GoogleHeatmap from "./GoogleHeatmap";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "antd";
import ShareIcon from "../../assets/WidgetMaker/share-icon.svg";
import PostCard from "./PostCard";
import ReviewCard from "./ReviewCard";
import { kFormatter } from "../../redux/constants";
import NoGraphData from "../workspace/DisplayChart/NoGraphData";
import ErrorBoundary from "../../ErrorBoundary";
import AuthorCard from "./AuthorCard";
import TatSummary from "../layout2/ORMWidget/TatSummary";
import KpiClickableWidget from "../layout2/KpiClickableWidget/index";
import isEqual from "react-fast-compare";
import RealtimeGrid from "./RealtimeGrid";
import RichTextWidget from "./RichTextWidget";
import StaticGoogleMap from "./StaticGoogleMap";
import MultiClusterNetworkGraph from "../utils/charts/VisCharts/MultiClusterNetworkGraph";
import MultiClusterNetworkGraphV2 from "../utils/charts/VisCharts/NetworkGraphV2/MultiClusterNetworkGraphV2";
import MultiNetowrkGraphUsingClusteringV2 from "../utils/charts/VisCharts/NetworkGraphV2/MultiNetowrkGraphUsingClusteringV2";
import { isString } from "highcharts";
import { getCountryLogo, getGenderLogo } from "../utils/Logos";
import defaultImage from "../../assets/brandLogos/Default_Brand.svg";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import CircularKpi from "../commandCenter/components/Widgets/CircularKpi/CircularKpi";
import SurveyCard from "./SurveyCard";
import RichContentContainer from "./RichContent/RichContentContainer";
import { SecondstoHumanReadable } from "../utils/charts/HighCharts/graphFunction";
import NewsCard from "../layout/DeepDive/DeepDivetab/Mentions/NewsCard";
import { sampleDataForMap } from "../../redux/constants/enums";
import GoogleMultiLayerMap from "./MultiLayerMap/GoogleMultiLayerMap";
import GoogleStaticMultiLayerMap from "./MultiLayerMap/GoogleStaticMultiLayerMap";
import ClusterChart from "../utils/charts/ClusterChart/ClusterChart";
import AdvGrid from "./AdvGrid/AdvGrid";
// import GridChart from "./GridChart";

const GraphList = ({
  widgetMakerGraphData,
  single,
  networkLinkLength,
  style,
  desc,
  log,
  scaleFromZeroToOne,
  xaxis,
  yaxis,
  id,
  type,
  stacked,
  legend_position,
  show_legend,
  chartGlobalDataLabel,
  chartShowDetailsOnCard,
  chartAxisLabel = true,
  chartDataLabelInPercent,
  chartGradientColor,
  chartGlobalDataStacked,
  chartXaxisDataLabel,
  chartMarkers,
  showAsMedian,
  xAxisChartType,
  yAxisChartType,
  xAxisScale,
  yAxisScale,
  y_series2,
  preview,
  yAxisMode,
  metadata,
  widgetShareOfData,
  widgetDurationComparison,
  widgetDurationComparisonForChart,
  widgetDurationDataForChart,
  hideColumns,
  hideSorting,
  dateLabels,
  refWidth,
  dashboard,
  span_data,
  section_index,
  chartShow3d,
  chart3dOption,
  widget_index,
  trends,
  metaDataCheck,
  isPreviewState,
  isdownload,
  metaWidgetKpiData,
  noteExist,
  insightsExist,
  template_widget,
  template_id,
  trends_type,
  AiInsights,
  widgetDiscription,
  chartStyles,
  isWidgetMakerPreview = false,
  richFieldsContent = null,
}) => {
  const [mapData, setMapData] = useState([]);
  const isPPTModalOpen = useSelector((state) => state.PPT.isPPTModalOpen);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const gridConfig = useSelector(
    (state) =>
      state?.GraphConfig?.widgetGraphConfig?.chart_settings?.grid_config || {}
  );

  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const PdfDownloadStatus = useSelector(
    (state) => state.PdfDownloadData.PdfDownloadStatus
  );
  useEffect(() => {
    if (type === "map") {
      let mainData = [];
      single[0]?.latitude?.map((data, i) => {
        mainData.push({
          label: i,
          lat: data,
          lng: single[0]?.longitude[i],
          name: single[0]?.names ? single[0]?.names[i] : "No Name",
          weight: single[0]?.weight
            ? single[0]?.weight[i]
            : single[0]?.count
            ? single[0]?.count[i]
            : 0,
        });
      });
      setMapData(mainData);
    } else if (type === "retweet_map" || type === "reply_map") {
      let mainData = [];
      single?.latitude?.map((data, i) => {
        mainData.push({
          label: i,
          lat: data,
          lng: single?.longitude[i],
          name: single?.names ? single?.names[i] : "No Name",
          weight: single?.weight
            ? single?.weight[i]
            : single?.count
            ? single?.count[i]
            : 0,
        });
      });
      setMapData(mainData);
    }
  }, [type]);
  const TooltipFormatter = (num) => {
    if (num) {
      if (Math.abs(num)) {
        return (Math.round(num * 100) / 100).toFixed(2)?.toLocaleString();
      } else return num;
    } else return "";
  };
  return (
    <>
      {type === "text" && (
        <>
          <RichTextWidget
            data={widgetMakerGraphData?.data}
            section_index={section_index}
            widget_index={widget_index}
            dashboard={dashboard}
            PdfDownloadStatus={isdownload ? isdownload : false}
            PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
            noteExist={noteExist}
            insightsExist={insightsExist}
            chart_type={type}
            AiInsights={AiInsights}
            id={id ? id : type}
            style={style}
          />
        </>
      )}
      {type === "rich-text" && (
        <>
          <RichContentContainer
            data={widgetMakerGraphData?.data}
            section_index={section_index}
            widget_index={widget_index}
            dashboard={dashboard}
            PdfDownloadStatus={isdownload ? isdownload : false}
            PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
            noteExist={noteExist}
            chart_type={type}
            id={id ? id : type}
            style={style}
            metadata={metadata}
            isPreviewState={isPreviewState}
            isWidgetMakerPreview={isWidgetMakerPreview}
            richFieldsContent={richFieldsContent}
          />
        </>
      )}
      {type === "bubble" && (
        <>
          <BubbleChart
            uniqueId={uuid()}
            single={single[0]?.data}
            style={style}
            WidgetEdit="edit"
            legend_position={legend_position}
            show_legend={show_legend}
            widget_index={widget_index}
            section_index={section_index}
            PdfDownloadStatus={isdownload}
            AiInsights={AiInsights}
          />
        </>
      )}
      {type === "number-line" && (
        <KpiClickableWidget
          preview={preview}
          single={single?.data}
          style={style}
          metadata={metadata}
          widget_index={widget_index}
          section_index={section_index}
          AiInsights={AiInsights}
        />
      )}
      {type === "number-tree" && (
        <>
          <TatSummary
            // tat={tat}
            // defualtvalue={defualtvalue}
            preview={preview}
            single={single?.data}
          />
        </>
      )}

      {type === "wordcloud" && (
        <>{/* <WordRecloudChart single={single} id={uuid()} /> */}</>
      )}

      {(type === "grid" || type === "pivot-grid") && (
        <>
          {metadata?.data_source === "realtime" ? (
            <RealtimeGrid
              tableColumns={
                single && single[0]?.columns?.length > 0 && single[0]?.columns
              }
              tree_grid={
                single && single[0]?.columns?.length > 0 && single[0]?.tree_grid
              }
              grand_total={
                single &&
                single[0]?.columns?.length > 0 &&
                single[0]?.grand_total
              }
              dataSource={
                single?.[0]?.dataSource
                  ? single[0]?.dataSource
                  : single?.[0]?.datasource
              }
              colors={single && single[0]?.colors}
              PdfDownloadStatus={
                isdownload
                  ? isdownload
                  : isPPTModalOpen
                  ? isPPTModalOpen
                  : false
              }
              metadata={metadata}
              noteExist={noteExist}
              insightsExist={insightsExist}
              section_index={section_index}
              widget_index={widget_index}
              hideColumns={[
                ...(hideColumns && Array.isArray(hideColumns)
                  ? hideColumns
                  : []),
                ...(single?.[0]?.hide_columns &&
                Array.isArray(single?.[0]?.hide_columns)
                  ? single[0]?.hide_columns
                  : []),
              ]}
              hideSorting={[
                ...(hideSorting && Array.isArray(hideSorting)
                  ? hideSorting
                  : []),
                ...(single?.[0]?.hide_sorting &&
                Array.isArray(single?.[0]?.hide_sorting)
                  ? single[0]?.hide_sorting
                  : []),
              ]}
              preview={preview}
            />
          ) : (
            <AdvGrid
              gridConfig={
                metadata?.chart?.chart_settings?.grid_config ||
                metadata?.chart_settings?.grid_config ||
                gridConfig
              }
              tableColumns={
                single && single[0]?.columns?.length > 0 && single[0]?.columns
              }
              tree_grid={
                single && single[0]?.columns?.length > 0 && single[0]?.tree_grid
              }
              rowSpanOn={
                single?.[0]?.columns?.length > 0 && single?.[0]?.row_span_on
              }
              grand_total={
                single &&
                single[0]?.columns?.length > 0 &&
                single[0]?.grand_total
              }
              dataSource={
                single?.[0]?.dataSource
                  ? single[0]?.dataSource
                  : single?.[0]?.datasource
              }
              colors={single && single[0]?.colors}
              PdfDownloadStatus={
                isdownload
                  ? isdownload
                  : isPPTModalOpen
                  ? isPPTModalOpen
                  : false
              }
              metadata={metadata}
              noteExist={noteExist}
              insightsExist={insightsExist}
              widgetDurationComparisonForChart={
                widgetDurationComparisonForChart
              }
              widgetDurationDataForChart={widgetDurationDataForChart}
              hideColumns={[
                ...(hideColumns && Array.isArray(hideColumns)
                  ? hideColumns
                  : []),
                ...(single?.[0]?.hide_columns &&
                Array.isArray(single?.[0]?.hide_columns)
                  ? single[0]?.hide_columns
                  : []),
              ]}
              hideSorting={[
                ...(hideSorting && Array.isArray(hideSorting)
                  ? hideSorting
                  : []),
                ...(single?.[0]?.hide_sorting &&
                Array.isArray(single?.[0]?.hide_sorting)
                  ? single[0]?.hide_sorting
                  : []),
              ]}
              dateLabels={dateLabels}
              preview={preview}
              section_index={section_index}
              widget_index={widget_index}
              dashboard={dashboard}
              isdownload={isdownload}
              isPPTModalOpen={isPPTModalOpen}
              type={type}
            />
          )}
          {/* (
            <GridChart
              gridConfig={
                metadata?.chart?.chart_settings?.grid_config ||
                metadata?.chart_settings?.grid_config ||
                gridConfig
              }
              tableColumns={
                single && single[0]?.columns?.length > 0 && single[0]?.columns
              }
              tree_grid={
                single && single[0]?.columns?.length > 0 && single[0]?.tree_grid
              }
              rowSpanOn={
                single?.[0]?.columns?.length > 0 && single?.[0]?.row_span_on
              }
              grand_total={
                single &&
                single[0]?.columns?.length > 0 &&
                single[0]?.grand_total
              }
              dataSource={
                single?.[0]?.dataSource
                  ? single[0]?.dataSource
                  : single?.[0]?.datasource
              }
              colors={single && single[0]?.colors}
              PdfDownloadStatus={
                isdownload
                  ? isdownload
                  : isPPTModalOpen
                  ? isPPTModalOpen
                  : false
              }
              metadata={metadata}
              noteExist={noteExist}
              insightsExist={insightsExist}
              widgetDurationComparisonForChart={
                widgetDurationComparisonForChart
              }
              widgetDurationDataForChart={widgetDurationDataForChart}
              hideColumns={[
                ...(hideColumns && Array.isArray(hideColumns)
                  ? hideColumns
                  : []),
                ...(single?.[0]?.hide_columns &&
                Array.isArray(single?.[0]?.hide_columns)
                  ? single[0]?.hide_columns
                  : []),
              ]}
              hideSorting={[
                ...(hideSorting && Array.isArray(hideSorting)
                  ? hideSorting
                  : []),
                ...(single?.[0]?.hide_sorting &&
                Array.isArray(single?.[0]?.hide_sorting)
                  ? single[0]?.hide_sorting
                  : []),
              ]}
              dateLabels={dateLabels}
              preview={preview}
              section_index={section_index}
              widget_index={widget_index}
              dashboard={dashboard}
            />
          ) */}
        </>
      )}
      {type === "map" && (
        <>
          {mapData && (
            <>
              {authParams?.ppt || isdownload ? (
                <StaticGoogleMap
                  data={mapData}
                  centerData={{ lat: mapData[0]?.lat, lng: mapData[0]?.lng }}
                  preview={preview}
                  createdWidget={true}
                  refWidth={refWidth}
                  PdfDownloadStatus={
                    isdownload
                      ? isdownload
                      : isPPTModalOpen
                      ? isPPTModalOpen
                      : false
                  }
                  noteExist={noteExist}
                  insightsExist={insightsExist}
                  widgetDiscription={widgetDiscription}
                />
              ) : (
                <>
                  <GoogleHeatmap
                    key={`heatmap-${JSON.stringify(mapData.slice(0, 3))}`}
                    data={mapData}
                    center={{ lat: mapData[0]?.lat, lng: mapData[0]?.lng }}
                    preview={preview}
                    createdWidget={true}
                    refWidth={refWidth}
                    region="IN"
                    PdfDownloadStatus={
                      isdownload
                        ? isdownload
                        : isPPTModalOpen
                        ? isPPTModalOpen
                        : false
                    }
                    noteExist={noteExist}
                    insightsExist={insightsExist}
                    widgetDiscription={widgetDiscription}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
      {(type === "retweet_map" || type === "reply_map") && (
        <>
          {mapData && (
            <>
              {authParams?.ppt || isdownload ? (
                <StaticGoogleMap
                  data={mapData}
                  centerData={{ lat: mapData[0]?.lat, lng: mapData[0]?.lng }}
                  preview={preview}
                  createdWidget={true}
                  refWidth={refWidth}
                  PdfDownloadStatus={
                    isdownload
                      ? isdownload
                      : isPPTModalOpen
                      ? isPPTModalOpen
                      : false
                  }
                  noteExist={noteExist}
                  insightsExist={insightsExist}
                  widgetDiscription={widgetDiscription}
                />
              ) : (
                <GoogleHeatmap
                  key={`heatmap-${type}-${JSON.stringify(mapData.slice(0, 3))}`}
                  mapType={type}
                  data={mapData}
                  center={{ lat: mapData[0]?.lat, lng: mapData[0]?.lng }}
                  preview={preview}
                  createdWidget={true}
                  trands={trends}
                  refWidth={refWidth}
                  mapCount={single?.count}
                  sentimentType={single?.sentiment_type}
                  PdfDownloadStatus={isdownload}
                  noteExist={noteExist}
                  insightsExist={insightsExist}
                  widgetDiscription={widgetDiscription}
                />
              )}
            </>
          )}
        </>
      )}
      {type === "multilayer-map" ? (
        <>
          {authParams?.ppt || isdownload ? (
            <>
              <GoogleStaticMultiLayerMap
                mapData={single}
                preview={preview}
                createdWidget={true}
                refWidth={refWidth}
                PdfDownloadStatus={
                  isdownload
                    ? isdownload
                    : isPPTModalOpen
                    ? isPPTModalOpen
                    : false
                }
                noteExist={noteExist}
                insightsExist={insightsExist}
                widgetDiscription={widgetDiscription}
                widget_id={id ?? type}
                region={"IN"}
              />
            </>
          ) : (
            <>
              <GoogleMultiLayerMap
                mapData={single}
                preview={preview}
                createdWidget={true}
                refWidth={refWidth}
                PdfDownloadStatus={
                  isdownload
                    ? isdownload
                    : isPPTModalOpen
                    ? isPPTModalOpen
                    : false
                }
                noteExist={noteExist}
                insightsExist={insightsExist}
                widgetDiscription={widgetDiscription}
                widget_id={id ?? type}
                widgetDurationShowPercentChange={
                  widgetDurationComparisonForChart
                }
                widgetDurationShowData={widgetDurationDataForChart}
                region={"IN"}
              />
              {/* <GoogleMarkerMap
                    data={mapData}
                    center={{ lat: mapData[0]?.lat, lng: mapData[0]?.lng }}
                    preview={preview}
                    createdWidget={true}
                    refWidth={refWidth}
                    PdfDownloadStatus={
                      isdownload
                        ? isdownload
                        : isPPTModalOpen
                        ? isPPTModalOpen
                        : false
                    }
                    noteExist={noteExist}
                    insightsExist={insightsExist}
                    widgetDiscription={widgetDiscription}
                    widget_id={id ?? type}
                  /> */}
              {/* <MultiLayerMap /> */}
              {/* <MapComponent /> */}
            </>
          )}
        </>
      ) : (
        ""
      )}
      {(type === "post-card" || type === "prolific-user") &&
        widgetMakerGraphData[0]?.data && (
          <div
            className={`bg__gray ${isdownload && !noteExist ? "h-100" : ""}`}
          >
            {/* <Influencer
              data={widgetMakerGraphData[0]?.data}
            /> */}
            <PostCard
              data={widgetMakerGraphData[0]?.data}
              filterPills={widgetMakerGraphData[0]["filter-pills"]}
              totalPageNo={widgetMakerGraphData[0].no_of_pages}
              metadata={metaDataCheck ? metadata : ""}
              section_index={section_index}
              widget_index={widget_index}
              pagination={true}
              isPreviewState={isPreviewState}
              dashboard={dashboard}
              PdfDownloadStatus={isdownload ? isdownload : false}
              PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
              noteExist={noteExist}
              insightsExist={insightsExist}
              chart_type={type}
              AiInsights={AiInsights}
            />
          </div>
        )}
      {type === "news-card" && widgetMakerGraphData[0]?.data && (
        <div
          className={`bg__gray ${
            isdownload && !noteExist ? "h-100" : ""
          } text-gray`}
        >
          <NewsCard
            newsDatas={widgetMakerGraphData[0]}
            filterPills={widgetMakerGraphData[0]["filter-pills"]}
            totalPageNo={widgetMakerGraphData[0].no_of_pages}
            metadata={metaDataCheck ? metadata : ""}
            section_index={section_index}
            widget_index={widget_index}
            pagination={true}
            isPreviewState={isPreviewState}
            dashboard={dashboard}
            PdfDownloadStatus={isdownload ? isdownload : false}
            PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
            noteExist={noteExist}
            insightsExist={insightsExist}
            chart_type={type}
            AiInsights={AiInsights}
          />
        </div>
      )}
      {type === "survey-card" && widgetMakerGraphData?.[0]?.data && (
        <div className={`bg__gray ${isdownload && !noteExist ? "h-100" : ""}`}>
          {/* <Influencer
              data={widgetMakerGraphData[0]?.data}
            /> */}
          <SurveyCard
            data={widgetMakerGraphData?.[0]?.data}
            filterPills={widgetMakerGraphData?.[0]["filter-pills"]}
            totalPageNo={widgetMakerGraphData?.[0].no_of_pages}
            metadata={metaDataCheck ? metadata : ""}
            section_index={section_index}
            widget_index={widget_index}
            pagination={true}
            isPreviewState={isPreviewState}
            dashboard={dashboard}
            PdfDownloadStatus={isdownload ? isdownload : false}
            PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
            noteExist={noteExist}
            insightsExist={insightsExist}
            chart_type={type}
            AiInsights={AiInsights}
            widget_id={id}
          />
        </div>
      )}
      {!metaWidgetKpiData && type === "kpi" && (
        <>
          {single && single?.length == 0 ? (
            <>
              <ErrorBoundary>
                <NoGraphData errorCode="No Data Found" />
              </ErrorBoundary>
            </>
          ) : (
            <>
              {trends
                ? single && (
                    <div
                      className={`d-flex gap-6 p-6 ${
                        type === "kpi" ? "bg__gray" : ""
                      } flex-wrap w-100 wm-chart-cards`}
                    >
                      {single?.map((data, i) => {
                        const valueArray =
                          isNaN(data?.value) && data?.value?.split(",");
                        let channelImage =
                          isString(data?.text) && data?.text?.includes("|$|")
                            ? data?.text?.split("|$|")?.[0]?.trim()
                            : null;
                        let ProfileName =
                          isString(data?.text) && data?.text?.includes("|$|")
                            ? data?.text?.split("|$|")?.[1]?.trim()
                            : null;
                        let profile_filter_flag =
                          data?.[0]?.text?.includes("|$|");
                        let genderName =
                          isString(data?.text) && data?.text?.includes("|G|")
                            ? data?.text?.split("|G|")?.[1]?.trim()
                            : null;
                        let countryName =
                          isString(data?.text) && data?.text?.includes("|C|")
                            ? data?.text?.split("|C|")?.[1]?.trim()
                            : null;
                        if (data?.length > 0) {
                          return data?.map((el, i) => {
                            return (
                              <div
                                // className={`w-100 ${
                                //   i === 2
                                //     ? ""
                                //     : "border-right border-color mr-15 pr-15"
                                // }`}
                                className="portlet1 border-radius-16 border-color pt-4 pb-4 text-center"
                                style={{ flex: "1 0 calc(25% - 3rem)" }}
                              >
                                <div className="text_regular text-ellipsis font-weight500 mb-1 line-height-normal">
                                  <Tooltip
                                    title={
                                      channelImage ? (
                                        <>
                                          <img
                                            style={{
                                              width: "1.5rem",
                                              height: "1.5rem",
                                              margin: "0.5rem",
                                            }}
                                            src={
                                              channelImage
                                                ? SocialMedialogo?.[
                                                    channelImage
                                                  ]
                                                : defaultImage
                                            }
                                          />
                                          {ProfileName}
                                        </>
                                      ) : genderName ? (
                                        <>
                                          <img
                                            style={{
                                              width: "1.5rem",
                                              height: "1.5rem",
                                              margin: "0.5rem",
                                            }}
                                            src={getGenderLogo(genderName)}
                                          />
                                          {genderName}
                                        </>
                                      ) : countryName ? (
                                        <>
                                          {getCountryLogo(countryName)}
                                          {countryName}
                                        </>
                                      ) : (
                                        <>
                                          {el?.attribute === "Rating"
                                            ? `${el?.text} ⭐`
                                            : el?.text}
                                        </>
                                      )
                                    }
                                    placement="top"
                                    className="text-ellipsis d-block"
                                  >
                                    {" "}
                                    {channelImage ? (
                                      <>
                                        <img
                                          style={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            margin: "0.5rem",
                                          }}
                                          src={
                                            channelImage
                                              ? SocialMedialogo?.[channelImage]
                                              : defaultImage
                                          }
                                        />
                                        {ProfileName}
                                      </>
                                    ) : genderName ? (
                                      <>
                                        <img
                                          style={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            margin: "0.5rem",
                                          }}
                                          src={getGenderLogo(genderName)}
                                        />
                                        {genderName}
                                      </>
                                    ) : countryName ? (
                                      <>
                                        {getCountryLogo(countryName)}
                                        {countryName}
                                      </>
                                    ) : (
                                      <>
                                        {el?.attribute === "Rating"
                                          ? `${el?.text} ⭐`
                                          : el?.text}
                                      </>
                                    )}
                                  </Tooltip>
                                </div>
                                <div className="d-flex align-items-baseline justify-content-center">
                                  <span className="wm-chart-card-value mr-1">
                                    {graphConditionConfig?.round_kpi_attrs?.includes(
                                      data?.attribute
                                    )
                                      ? isNaN(el?.value) &&
                                        valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(el?.value, false, true)
                                      : isNaN(el?.value) &&
                                        valueArray?.length > 1
                                      ? valueArray[0] + " " + valueArray[1]
                                      : kFormatter(el?.value, true)}
                                  </span>
                                  {widgetDurationComparison ? (
                                    <span
                                      className={`text_regular text-ellipsis ${
                                        el?.percent_change === 0
                                          ? "d-flex"
                                          : "d-flex"
                                      } align-items-baseline ${
                                        String(el?.text).toLowerCase() ===
                                        String("Negative").toLowerCase()
                                          ? el?.percent_change > 0
                                            ? "negative"
                                            : el?.percent_change < 0
                                            ? "positive"
                                            : "text-gray"
                                          : el?.percent_change > 0
                                          ? "positive"
                                          : el?.percent_change < 0
                                          ? "negative"
                                          : "text-gray"
                                      } font-size12`}
                                    >
                                      {el?.percent_change > 0 ? (
                                        <>
                                          <CaretUpFilled className="font-size18" />
                                          {" " +
                                            Number(
                                              el?.percent_change
                                            )?.toLocaleString() +
                                            "%"}
                                        </>
                                      ) : el?.percent_change < 0 ? (
                                        <>
                                          <CaretDownFilled className="font-size18" />
                                          {" " +
                                            Number(
                                              el?.percent_change
                                            )?.toLocaleString() +
                                            "%"}
                                        </>
                                      ) : (
                                        el?.percent_change !== null && "NA"
                                      )}{" "}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            );
                          });
                        } else {
                          return (
                            <div
                              // className={`wm-chart-cards-item trand_detail_list ${
                              //   i === 5 && "trands__margin-right"
                              // } mb-15 ${
                              //   i === 6 ? "" : "mr-15"
                              // } p-15 box-shadow border-radius-4`}
                              // style={{
                              //   width: i === 6 ? "25%" : "calc(25% - 1.5rem)",
                              // }}
                              className="portlet1 border-radius-16 border-color pt-4 pb-4 text-center"
                              style={{ flex: "1 0 calc(25% - 3rem)" }}
                            >
                              <div className="text_regular font-weight500 mb-1 line-height-normal text-center">
                                <Tooltip
                                  title={
                                    channelImage ? (
                                      <>
                                        <img
                                          style={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            margin: "0.5rem",
                                          }}
                                          src={
                                            channelImage
                                              ? SocialMedialogo?.[channelImage]
                                              : defaultImage
                                          }
                                        />
                                        {ProfileName}
                                      </>
                                    ) : genderName ? (
                                      <>
                                        <img
                                          style={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            margin: "0.5rem",
                                          }}
                                          src={getGenderLogo(genderName)}
                                        />
                                        {genderName}
                                      </>
                                    ) : countryName ? (
                                      <>
                                        {getCountryLogo(countryName)}
                                        {countryName}
                                      </>
                                    ) : (
                                      <>
                                        {data?.attribute === "Rating"
                                          ? `${data?.text} ⭐`
                                          : data?.text}
                                      </>
                                    )
                                  }
                                  placement="top"
                                  className="text-ellipsis d-inline-block"
                                >
                                  {channelImage ? (
                                    <>
                                      <img
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                          margin: "0.5rem",
                                        }}
                                        src={
                                          channelImage
                                            ? SocialMedialogo?.[channelImage]
                                            : defaultImage
                                        }
                                      />
                                      {ProfileName}
                                    </>
                                  ) : genderName ? (
                                    <>
                                      <img
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                          margin: "0.5rem",
                                        }}
                                        src={getGenderLogo(genderName)}
                                      />
                                      {genderName}
                                    </>
                                  ) : countryName ? (
                                    <>
                                      {getCountryLogo(countryName)}
                                      {countryName}
                                    </>
                                  ) : (
                                    <>
                                      {data?.attribute === "Rating"
                                        ? `${
                                            data?.text?.length >= 40
                                              ? `${data?.text.substring(
                                                  0,
                                                  40
                                                )}...`
                                              : data?.text
                                          } ⭐`
                                        : data?.text?.length >= 40
                                        ? `${data?.text.substring(0, 40)}...`
                                        : data?.text}
                                    </>
                                  )}
                                </Tooltip>
                                {data?.info_help_text && (
                                  <Tooltip
                                    title={data?.info_help_text}
                                    placement="top"
                                    className="text-ellipsis d-inline-block"
                                  >
                                    <i className="fa fa-question-circle cursor-pointer ml-1" />
                                  </Tooltip>
                                )}
                              </div>
                              <div className="d-flex align-items-baseline justify-content-center">
                                <Tooltip
                                  placement="bottom"
                                  title={TooltipFormatter(data?.value)}
                                >
                                  <span
                                    className="wm-chart-card-value mr-1"
                                    style={{
                                      color:
                                        data?.color !== "#000000"
                                          ? data?.color
                                          : "",
                                    }}
                                  >
                                    {graphConditionConfig?.round_kpi_attrs?.includes(
                                      data?.attribute
                                    )
                                      ? isNaN(data?.value) &&
                                        valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(data?.value, false, true)
                                      : isNaN(data?.value) &&
                                        valueArray?.length > 1
                                      ? valueArray[0] + " " + valueArray[1]
                                      : kFormatter(data?.value, true)}
                                  </span>
                                </Tooltip>
                                {data && (
                                  <span
                                    className={`text_regular ${
                                      data?.percent_change === 0
                                        ? "d-flex"
                                        : "d-flex"
                                    } align-items-baseline ${
                                      String(data?.text).toLowerCase() ===
                                      String("Negative").toLowerCase()
                                        ? data?.percent_change > 0
                                          ? "negative"
                                          : data?.percent_change < 0
                                          ? "positive"
                                          : "text-gray"
                                        : data?.percent_change > 0
                                        ? "positive"
                                        : data?.percent_change < 0
                                        ? "negative"
                                        : "text-gray"
                                    } font-size12`}
                                  >
                                    {data?.percent_change > 0 ? (
                                      <>
                                        <CaretUpFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : data?.percent_change < 0 ? (
                                      <>
                                        <CaretDownFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : (
                                      data?.percent_change !== null && "NA"
                                    )}{" "}
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  )
                : single && (
                    <div
                      className={`d-flex gap-6 p-6 ${
                        type === "kpi" ? "bg__gray" : ""
                      } flex-wrap w-100 wm-chart-cards`}
                    >
                      {single?.map((data) => {
                        const valueArray =
                          isNaN(data?.value) && data?.value?.split(",");
                        let channelImage =
                          isString(data?.text) && data?.text?.includes("|$|")
                            ? data?.text?.split("|$|")?.[0]?.trim()
                            : null;
                        let ProfileName =
                          isString(data?.text) && data?.text?.includes("|$|")
                            ? data?.text?.split("|$|")?.[1]?.trim()
                            : null;
                        let profile_filter_flag =
                          data?.[0]?.text?.includes("|$|");
                        let genderName =
                          isString(data?.text) && data?.text?.includes("|G|")
                            ? data?.text?.split("|G|")?.[1]?.trim()
                            : null;
                        let countryName =
                          isString(data?.text) && data?.text?.includes("|C|")
                            ? data?.text?.split("|C|")?.[1]?.trim()
                            : null;
                        return (
                          <div
                            className="portlet1 border-radius-16 border-color pt-4 pb-4 text-center"
                            style={
                              data?.color && data?.color?.trim() != "#000000"
                                ? {
                                    border: data?.border_color
                                      ? `3px solid ${data?.border_color}66`
                                      : "3px solid var(--locobuzz-border-color)",
                                    boxShadow:
                                      "0 0 0.6rem " +
                                      data?.color?.trim() +
                                      "10",
                                    // border:
                                    //   "0.1rem solid " + data?.color?.trim() + "80",
                                    backgroundColor: data?.color?.trim() + "30",
                                    //borderRadius: "0.4rem",
                                    color: "#",
                                    flex: "1 0 calc(25% - 3rem)",
                                  }
                                : {
                                    border:
                                      "3px solid var(--locobuzz-border-color)",
                                    boxShadow:
                                      authParams?.theme_type === "1"
                                        ? "0 0 0.6rem #f1f1f266"
                                        : "0 0 0.6rem #c3cbd710",
                                    //borderRadius: "0.4rem",
                                    // border:
                                    //   authParams?.theme_type === "1"
                                    //     ? "0.1rem solid transparent"
                                    //     : "0.1rem solid #c3cbd7",
                                    // backgroundColor:
                                    //   authParams?.theme_type === "1"
                                    //     ? ""
                                    //     : "#f9f9f9",
                                    flex: "1 0 calc(25% - 3rem)",
                                  }
                            }
                          >
                            <div className="wm-chart-card-title font-weight500 mb-1 line-height-normal">
                              <Tooltip
                                title={
                                  channelImage ? (
                                    <>
                                      <img
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                          margin: "0.5rem",
                                        }}
                                        src={
                                          channelImage
                                            ? SocialMedialogo?.[channelImage]
                                            : defaultImage
                                        }
                                      />
                                      {ProfileName}
                                    </>
                                  ) : genderName ? (
                                    <>
                                      <img
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                          margin: "0.5rem",
                                        }}
                                        src={getGenderLogo(genderName)}
                                      />
                                      {genderName}
                                    </>
                                  ) : countryName ? (
                                    <>
                                      {getCountryLogo(countryName)}
                                      {countryName}
                                    </>
                                  ) : (
                                    <>
                                      {data?.attribute === "Rating"
                                        ? `${data?.text} ⭐`
                                        : data?.text}
                                    </>
                                  )
                                }
                                placement="top"
                                className="text-ellipsis d-inline-block"
                              >
                                {channelImage ? (
                                  <>
                                    <img
                                      style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                        margin: "0.5rem",
                                      }}
                                      src={
                                        channelImage
                                          ? SocialMedialogo?.[channelImage]
                                          : defaultImage
                                      }
                                    />
                                    {ProfileName}
                                  </>
                                ) : genderName ? (
                                  <>
                                    <img
                                      style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                        margin: "0.5rem",
                                      }}
                                      src={getGenderLogo(genderName)}
                                    />
                                    {genderName}
                                  </>
                                ) : countryName ? (
                                  <>
                                    {getCountryLogo(countryName)}
                                    {countryName}
                                  </>
                                ) : (
                                  <>
                                    {data?.attribute === "Rating"
                                      ? `${
                                          data?.text?.length >= 40
                                            ? `${data?.text.substring(
                                                0,
                                                40
                                              )}...`
                                            : data?.text
                                        } ⭐`
                                      : data?.text?.length >= 40
                                      ? `${data?.text.substring(0, 40)}...`
                                      : data?.text}
                                  </>
                                )}
                              </Tooltip>
                              {data?.info_help_text && (
                                <Tooltip
                                  title={data?.info_help_text}
                                  placement="top"
                                  className="text-ellipsis d-inline-block"
                                >
                                  <i className="fa fa-question-circle cursor-pointer ml-1" />
                                </Tooltip>
                              )}
                              {data?.info_text && (
                                <Tooltip
                                  title={data?.info_text}
                                  placement="top"
                                  className="text-ellipsis d-inline-block"
                                >
                                  <i className="fa fa-info-circle cursor-pointer ml-1" />
                                </Tooltip>
                              )}
                            </div>
                            {widgetShareOfData && data?.share ? (
                              <>
                                <div className="d-flex align-items-baseline justify-content-center">
                                  <Tooltip
                                    placement="bottom"
                                    title={TooltipFormatter(data?.value)}
                                  >
                                    <span className="wm-chart-card-value mr-1 ">
                                      {graphConditionConfig?.[ // seconds formatting in KPI
                                        "ticket-time-label-attrs"
                                      ]
                                        ?.includes(data?.y_series?.attribute)
                                        ? SecondstoHumanReadable(data.value)
                                        : graphConditionConfig?.round_kpi_attrs?.includes(
                                            data?.attribute
                                          )
                                        ? isNaN(data?.value) &&
                                          valueArray?.length > 1
                                          ? valueArray[0] + " " + valueArray[1]
                                          : kFormatter(data?.value, false, true)
                                        : isNaN(data?.value) &&
                                          valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(data?.value, true)}
                                    </span>
                                  </Tooltip>
                                  {data?.share ? (
                                    <span className="d-flex align-items-center font-size12 font-weight600 text-blue cursor-default ml-1 no--wrap">
                                      {/* <img
																	src={ShareIcon}
																	style={{ maxWidth: "1.5rem" }}
																	className="mr-1"
																/> */}
                                      <span
                                        className="pie__of--share mr-1"
                                        style={{
                                          border: "0.2rem solid " + "#185EDF",
                                          backgroundImage:
                                            "conic-gradient(" +
                                            "#185EDF " +
                                            data?.share * 3.6 +
                                            "deg,#ffff " +
                                            data?.share * 3.6 +
                                            "deg)",
                                        }}
                                      ></span>
                                      <span>{data?.share} %</span>
                                    </span>
                                  ) : (
                                    <span className="text_regular font-size12 font-weight600 text-gray"></span>
                                  )}
                                </div>
                                <div>
                                  {widgetDurationComparison ? (
                                    <span
                                      className={`text_regular justify-content-center ${
                                        data?.percent_change === 0
                                          ? "d-flex"
                                          : "d-flex"
                                      } align-items-baseline ${
                                        String(data?.text).toLowerCase() ===
                                        String("Negative").toLowerCase()
                                          ? data?.percent_change > 0
                                            ? "negative"
                                            : data?.percent_change < 0
                                            ? "positive"
                                            : "text-gray"
                                          : data?.percent_change > 0
                                          ? "positive"
                                          : data?.percent_change < 0
                                          ? "negative"
                                          : "text-gray"
                                      } font-size12`}
                                    >
                                      {data?.percent_change > 0 ? (
                                        <>
                                          <CaretUpFilled className="font-size18" />
                                          {" " +
                                            Number(
                                              data?.percent_change
                                            )?.toLocaleString() +
                                            "%"}
                                        </>
                                      ) : data?.percent_change < 0 ? (
                                        <>
                                          <CaretDownFilled className="font-size18" />
                                          {" " +
                                            Number(
                                              data?.percent_change
                                            )?.toLocaleString() +
                                            "%"}
                                        </>
                                      ) : (
                                        data?.percent_change !== null && "NA"
                                      )}{" "}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-baseline justify-content-center">
                                <Tooltip
                                  placement="bottom"
                                  title={TooltipFormatter(data?.value)}
                                >
                                  <span className="wm-chart-card-value mr-1">
                                    {graphConditionConfig?.[ // seconds formatting in KPI
                                      "ticket-time-label-attrs"
                                    ]
                                      ?.includes(data?.y_series?.attribute)
                                      ? SecondstoHumanReadable(data.value)
                                      : graphConditionConfig?.round_kpi_attrs?.includes(
                                          data?.attribute
                                        )
                                      ? isNaN(data?.value) &&
                                        valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(data?.value, false, true)
                                      : isNaN(data?.value) &&
                                        valueArray?.length > 1
                                      ? valueArray[0] + " " + valueArray[1]
                                      : kFormatter(data?.value, true)}
                                  </span>
                                </Tooltip>
                                {widgetDurationComparison ? (
                                  <span
                                    className={`text_regular ${
                                      data?.percent_change === 0
                                        ? "d-flex"
                                        : "d-flex"
                                    } align-items-baseline ${
                                      String(data?.text).toLowerCase() ===
                                      String("Negative").toLowerCase()
                                        ? data?.percent_change > 0
                                          ? "negative"
                                          : data?.percent_change < 0
                                          ? "positive"
                                          : "text-gray"
                                        : data?.percent_change > 0
                                        ? "positive"
                                        : data?.percent_change < 0
                                        ? "negative"
                                        : "text-gray"
                                    } font-size12`}
                                  >
                                    {data?.percent_change > 0 ? (
                                      <>
                                        <CaretUpFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : data?.percent_change < 0 ? (
                                      <>
                                        <CaretDownFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : (
                                      data?.percent_change !== null && "NA"
                                    )}{" "}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
            </>
          )}
        </>
      )}
      {type === "review-card" && (
        <>
          {widgetMakerGraphData && widgetMakerGraphData[0]?.data && (
            <div
              className={`bg__gray ${isdownload && !noteExist ? "h-100" : ""}`}
            >
              <ReviewCard
                data={widgetMakerGraphData[0]?.data}
                filterPills={widgetMakerGraphData[0]["filter-pills"]}
                totalPageNo={widgetMakerGraphData[0]?.no_of_pages}
                metadata={metaDataCheck ? metadata : ""}
                section_index={section_index}
                widget_index={widget_index}
                pagination={true}
                isPreviewState={isPreviewState}
                dashboard={dashboard}
                PdfDownloadStatus={isdownload ? isdownload : false}
                PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
                noteExist={noteExist}
                insightsExist={insightsExist}
                chart_type={type}
              />
            </div>
          )}
        </>
      )}

      {type === "author-card" && (
        <>
          {widgetMakerGraphData && widgetMakerGraphData[0]?.data && (
            <div
              className={`bg__gray pt-15 ${
                isdownload && !noteExist ? "h-100" : ""
              }`}
            >
              <AuthorCard
                data={widgetMakerGraphData[0]?.data}
                totalPageNo={widgetMakerGraphData[0]?.no_of_pages}
                metadata={metaDataCheck ? metadata : ""}
                section_index={section_index}
                widget_index={widget_index}
                pagination={true}
                isPreviewState={isPreviewState}
                dashboard={dashboard}
                PdfDownloadStatus={isdownload ? isdownload : false}
                PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
                noteExist={noteExist}
                insightsExist={insightsExist}
                chart_type={type}
                AiInsights={AiInsights}
              />
            </div>
          )}
        </>
      )}
      {type === "network-graph" ? (
        <MultiClusterNetworkGraph
          metadata={metadata}
          single={single}
          networkLinkLength={networkLinkLength}
          style={style}
          desc={desc}
          log={log}
          scaleFromZeroToOne={scaleFromZeroToOne}
          xaxis={xaxis}
          yaxis={yaxis}
          y_series2={y_series2}
          id={id ? id : type}
          type={type}
          stacked={stacked}
          legend_position={legend_position}
          chartGlobalDataLabel={chartGlobalDataLabel}
          chartDataLabelInPercent={chartDataLabelInPercent}
          chartGradientColor={chartGradientColor}
          chartGlobalDataStacked={chartGlobalDataStacked}
          chartXaxisDataLabel={chartXaxisDataLabel}
          chartMarkers={chartMarkers}
          xAxisChartType={xAxisChartType}
          yAxisChartType={yAxisChartType}
          xAxisScale={xAxisScale}
          yAxisScale={yAxisScale}
          yAxisMode={yAxisMode}
          dashboard={dashboard}
          span_data={span_data}
          widget_index={widget_index}
          section_index={section_index}
          PdfDownloadStatus={isdownload}
          template_widget={template_widget}
          template_id={template_id}
          trends_type={trends_type}
          AiInsights={AiInsights}
        ></MultiClusterNetworkGraph>
      ) : (
        ""
      )}
      {type === "network-graph-v2" ? (
        <MultiNetowrkGraphUsingClusteringV2
          metadata={metadata}
          single={single}
          networkLinkLength={networkLinkLength}
          style={style}
          desc={desc}
          log={log}
          scaleFromZeroToOne={scaleFromZeroToOne}
          xaxis={xaxis}
          yaxis={yaxis}
          y_series2={y_series2}
          id={id ? id : type}
          type={type}
          stacked={stacked}
          legend_position={legend_position}
          chartGlobalDataLabel={chartGlobalDataLabel}
          chartDataLabelInPercent={chartDataLabelInPercent}
          chartGradientColor={chartGradientColor}
          chartGlobalDataStacked={chartGlobalDataStacked}
          chartXaxisDataLabel={chartXaxisDataLabel}
          chartMarkers={chartMarkers}
          xAxisChartType={xAxisChartType}
          yAxisChartType={yAxisChartType}
          xAxisScale={xAxisScale}
          yAxisScale={yAxisScale}
          yAxisMode={yAxisMode}
          dashboard={dashboard}
          span_data={span_data}
          widget_index={widget_index}
          section_index={section_index}
          PdfDownloadStatus={isdownload}
          template_widget={template_widget}
          template_id={template_id}
          trends_type={trends_type}
          AiInsights={AiInsights}
        />
      ) : (
        // <MultiClusterNetworkGraphV2
        //   metadata={metadata}
        //   single={single}
        //   networkLinkLength={networkLinkLength}
        //   style={style}
        //   desc={desc}
        //   log={log}
        //   scaleFromZeroToOne={scaleFromZeroToOne}
        //   xaxis={xaxis}
        //   yaxis={yaxis}
        //   y_series2={y_series2}
        //   id={id ? id : type}
        //   type={type}
        //   stacked={stacked}
        //   legend_position={legend_position}
        //   chartGlobalDataLabel={chartGlobalDataLabel}
        //   chartDataLabelInPercent={chartDataLabelInPercent}
        //   chartGradientColor={chartGradientColor}
        //   chartGlobalDataStacked={chartGlobalDataStacked}
        //   chartXaxisDataLabel={chartXaxisDataLabel}
        //   chartMarkers={chartMarkers}
        //   xAxisChartType={xAxisChartType}
        //   yAxisChartType={yAxisChartType}
        //   xAxisScale={xAxisScale}
        //   yAxisScale={yAxisScale}
        //   yAxisMode={yAxisMode}
        //   dashboard={dashboard}
        //   span_data={span_data}
        //   widget_index={widget_index}
        //   section_index={section_index}
        //   PdfDownloadStatus={isdownload}
        //   template_widget={template_widget}
        //   template_id={template_id}
        //   trends_type={trends_type}
        //   AiInsights={AiInsights}
        // ></MultiClusterNetworkGraphV2>
        ""
      )}
      {(type === "combination" ||
        type === "bar" ||
        type === "horizontal-bar" ||
        type === "lollipop" ||
        type === "area" ||
        type === "line" ||
        type === "pie" ||
        type === "donut" ||
        type === "heatmap" ||
        type === "scatter" ||
        type === "quadrant" ||
        type === "sankey" ||
        type === "sunburst" ||
        type === "wordcloud" ||
        type === "organization" ||
        type === "treemap") && (
        <>
          {widgetMakerGraphData && (
            <HighCharts
              metadata={metadata}
              single={single}
              networkLinkLength={networkLinkLength}
              style={style}
              desc={desc}
              log={log}
              scaleFromZeroToOne={scaleFromZeroToOne}
              xaxis={xaxis}
              yaxis={yaxis}
              y_series2={y_series2}
              id={id ? id : type}
              type={type}
              stacked={stacked}
              legend_position={legend_position}
              show_legend={show_legend}
              chartGlobalDataLabel={chartGlobalDataLabel}
              chartShowDetailsOnCard={chartShowDetailsOnCard}
              chartShow3d={chartShow3d}
              chart3dOption={chart3dOption}
              chartAxisLabel={chartAxisLabel}
              chartDataLabelInPercent={chartDataLabelInPercent}
              chartGradientColor={chartGradientColor}
              chartGlobalDataStacked={chartGlobalDataStacked}
              chartXaxisDataLabel={chartXaxisDataLabel}
              chartMarkers={chartMarkers}
              chartStyles={chartStyles}
              showAsMedian={showAsMedian}
              xAxisChartType={xAxisChartType}
              yAxisChartType={yAxisChartType}
              xAxisScale={xAxisScale}
              yAxisScale={yAxisScale}
              yAxisMode={yAxisMode}
              dashboard={dashboard}
              span_data={span_data}
              widget_index={widget_index}
              section_index={section_index}
              PdfDownloadStatus={isdownload}
              template_widget={template_widget}
              template_id={template_id}
              trends_type={trends_type}
              AiInsights={AiInsights}
              metaWidgetGraphData={widgetMakerGraphData}
            />
          )}
        </>
      )}

      {type === "progress-kpi" && (
        <>
          <CircularKpi
            kpiData={widgetMakerGraphData}
            widget_index={widget_index}
            section_index={section_index}
          />
        </>
      )}

      {type === "cluster-chart" && (
        <>
          <ClusterChart
            cluster_chart_data={widgetMakerGraphData}
            metadata={metadata}
            PdfDownloadStatus={isdownload ? isdownload : false}
            PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
            widgetIndex={widget_index}
            sectionIndex={section_index}
            isPreviewState={isPreviewState}
          />
        </>
      )}
    </>
  );
};

export default React.memo(GraphList, isEqual);
